// services/fileUploadService.js
import instance from '../../../utils/axiosInstance';
/**
 * Sube todos los archivos de la encuesta en una sola petición
 * @param {string} surveyId - ID de la encuesta
 * @param {string} answerId - ID de la respuesta
 * @param {Array} formValues - Array de formValues
 * @param {Array} questions - Array de preguntas
 * @returns {Promise<Object>}
 */
export const uploadAllSurveyFiles = async (surveyId, answerId, formValues, questions, questionRefs = {}) => {
  try {
    const formData = new FormData();
    formData.append('SurveyId', surveyId);
    formData.append('AnswerId', answerId);

    let questionIndex = 0;
    let totalFiles = 0;

    for (const question of questions) {
      const formValue = formValues.find((fv) => fv.id === question.questionId);
      if (!formValue) continue;

      // Caso 1: Pregunta directa de Archivos
      if (question.typeQuestion === 'Archivos') {
        const files = formValue.fileObjects;
        if (files && Array.isArray(files) && files.length > 0) {
          formData.append(`Questions[${questionIndex}].QuestionId`, question.questionId);
          files.forEach((file) => {
            formData.append(`Questions[${questionIndex}].Files`, file);
            totalFiles++;
          });
          questionIndex++;
        }
      }

      // Caso 2: Pregunta compuesta con hijos de tipo Archivos
      if (question.typeQuestion === 'Compuesta') {
        const childFileQuestions = (question.childrenQuestions || []).filter(
          (c) => c.typeQuestion === 'Archivos'
        );
        if (childFileQuestions.length === 0) continue;

        // ✅ Leer selectedOptions reales del ref (tienen los File objects)
        const complexRef = questionRefs[question.questionId]?.current;
        const rawAnswers = complexRef?.getAnswers?.() || [];

        if (rawAnswers.length === 0) continue;

        for (const child of childFileQuestions) {
          for (const complexAnswer of rawAnswers) {
            const files = complexAnswer.selectedChildAnswers?.[child.questionId];
            if (!files || !Array.isArray(files)) continue;
            
            const realFiles = files.filter((f) => f instanceof File);
            if (realFiles.length === 0) continue;

            formData.append(`Questions[${questionIndex}].QuestionId`, child.questionId);
            formData.append(`Questions[${questionIndex}].OptionName`, complexAnswer.optionName ?? ''); 
            realFiles.forEach((file) => {
              formData.append(`Questions[${questionIndex}].Files`, file);
              totalFiles++;
            });
            questionIndex++;
          }
        }
      }
    }

    if (totalFiles === 0) {
      return { success: true, message: 'No hay archivos para subir', data: { uploadedFiles: [] } };
    }

    const response = await instance.post('/upload-question-files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return { success: true, data: response.data };

  } catch (error) {
    const errorMessage =
      error.response?.data?.Message ||
      error.response?.data?.message ||
      error.message ||
      'Error desconocido al subir archivos';

    return {
      success: false,
      error: errorMessage,
      errors: error.response?.data?.Errors,
    };
  }
};